import { TransparencyPortalLinkType } from "../../../types/types";
import { api } from "../api";

/**
 * Busca (ou cria) o link público do portal da transparência.
 * O customerId só é considerado para o dev (o gestor sempre usa o próprio cliente).
 * /transparency-portal/link?customerId={customerId}
 */
const findTransparencyPortalLink = async (token: string, customerId?: number) => {
    return api.get<TransparencyPortalLinkType>("/transparency-portal/link", {
        params: { customerId },
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

export default findTransparencyPortalLink;
